import React, { useState } from "react";
import { icon } from "../../config";
import { sortAlphabetically } from "../../helper/common";
import { useFormInteraction } from "./contexts/FormInteractionContext";

const UserChips = ({ userChipsArray = { Variables: [] }, searchTerm = "" }) => {
  const [expandLibrary, setExpandLibrary] = useState(true);
  const { setSelectedElement } = useFormInteraction();

  /**
   * Handles drag start for user chips
   * Converts user chip to form component format
   */
  const handleDragStart = (event, chip) => {
    event.dataTransfer.setData("component", JSON.stringify({ ...chip, type: "user chip", chipType: "user chip" }));
    event.dataTransfer.effectAllowed = "copy";
  };

  // Filter chips based on searchTerm and sort alphabetically
  const filteredChips = sortAlphabetically(
    searchTerm
      ? userChipsArray?.Variables?.filter((chip) => chip.name?.toLowerCase().includes(searchTerm.toLowerCase())) || []
      : userChipsArray?.Variables || [],
    "name"
  );

  return (
    <div className='component-library'>
      <div className='library-header'>
        <h5 className='library-title d-flex align-items-center justify-content-between'>
          User Profile Chips
          <span className='cursor-pointer text-right' onClick={() => setExpandLibrary(!expandLibrary)}>
            {expandLibrary ? icon.CHEVRON_UP : icon.CHEVRON_DOWN}
          </span>
        </h5>
      </div>
      <aside className='d-flex flex-column overflow-y-auto'>
        {expandLibrary && (
          <div className='components-list user-chips-library'>
            {filteredChips.length > 0 ? (
              filteredChips.map((chip) => {
                return (
                  <div
                    key={chip._id}
                    className='component-item'
                    draggable={true}
                    onDragStart={(e) => handleDragStart(e, chip)}
                    onClick={() => setSelectedElement({ ...chip, type: "user chip", chipType: "user chip" })}>
                    {icon.CONTACT_ROUND}
                    <span className='component-name'>{chip.name}</span>
                  </div>
                );
              })
            ) : (
              <div className='text-muted text-center p-3'>No user chips found</div>
            )}
          </div>
        )}
      </aside>
    </div>
  );
};

export default UserChips;
